import store from "../index";

export default {
    updateFormatListByCampaignId({commit, state}, campaign_id) {
        if (state.available_templates && state.available_formats) {
            let formats = state.available_formats.filter((format) => {
                let hasTemplate = state.available_templates.filter((template) => {
                    return (template.paper_format_id === format.id
                            && template.campaign_id === campaign_id);
                });
                if (hasTemplate.length)
                    return format;
            });
        commit('SET_FILTERED_PAPER_FORMATS', formats);
        }
    },

    updateThemesByTemplateId({commit, state}, template_id) {
        if (state.available_templates) {
            const template = state.available_templates.find((template) => {
                return template.id === template_id;
            });
            const themes = state.available_themes.filter((theme) => {
                const isFormatBought = ((theme.paper_format_id === template.paper_format_id)
                    && theme.bought);
                if (theme.id === template.theme_id || isFormatBought) {
                    return theme;
                }
            });

            themes.sort(function(a, b) {
                if(b.name < a.name)
                    return 1;

                if(b.name > a.name)
                    return -1;

                return 0;
            });
            commit('SET_FILTERED_THEMES', themes);
        }
    },

    updateTemplateByPaperFormatIdAndCampaignId({commit, state}, options) {
        if (state.available_templates) {
            let templates = state.available_templates.filter((template) => {
                if (template.paper_format_id == options.paper_format_id
                    && template.campaign_id == options.campaign_id)
                    return template;
            });

            templates.sort(function(a, b) {
                if(b.name < a.name)
                    return 1;

                if(b.name > a.name)
                    return -1;

                return 0;
            });

            commit('SET_FILTERED_TEMPLATES', templates);
        }
    },

    updateSelectedThemeById({commit, state}, theme_id) {

    },

    updateCampaignId({commit, state}, campaignId) {
        commit('SET_CAMPAIGN_ID', campaignId)
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/selector/actions.js